import React, { useEffect } from 'react';
import { useForm, FormProvider, useFormContext } from 'react-hook-form';

/**
 * @typedef {object} FormProps
 * @property {'onBlur' | 'onSubmit' | 'onChange' | 'onTouched' | 'all'} mode,
 * @property {'onBlur' | 'onSubmit' | 'onChange' } reValidateMode,
 * @property {'firstError', 'all'} criteriaMode
 * @property onSubmit
 * @property children
 * @property className
 */

/**
 * @param {FormProps} props
 */
export const Form = function Form(props) {
  const {
    mode,
    reValidateMode,
    model,
    criteriaMode,
    onSubmit,
    children,
    className } =
  {
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    criteriaMode: 'all',
    ...props };


  const form = useForm({
    mode,
    reValidateMode,
    defaultValues: model,
    criteriaMode });


  useEffect(() => {
    if (model) {
      form.reset(model);
    } else {
      form.reset();
    }
  }, [form, model]);

  return /*#__PURE__*/(
    React.createElement(FormProvider, form,
    typeof children === 'function' ?
    children(form) : /*#__PURE__*/

    React.createElement("form", {
      className: className,
      noValidate: true,
      onSubmit: form.handleSubmit((e) => onSubmit(e, form)) },

    children)));




};

export const FormField = function FormField({
  name,
  label,
  required,
  type,
  pattern,
  minLength,
  maxLength,
  children,
  onChange })
{
  const form = useFormContext();

  // onBlur, onChange, name, ref
  const inputProps = form.register(name, {
    required: required ? `${label || name} is required` : false,
    pattern:
    type === 'email' ?
    {
      value: /^([^\s@])+@(([^\s@.])+\.)+([^\s.]{2,})+$/i,
      message: 'Invalid email address' } :

    pattern,
    minLength: minLength ?
    {
      value: minLength,
      message: `${
      label || name
      } should be at least ${minLength} character long` } :

    undefined,
    maxLength: maxLength ?
    {
      value: maxLength,
      message: `${
      label || name
      } should be less than ${maxLength} character long` } :

    undefined });


  const inputOnChange = inputProps.onChange;
  inputProps.onChange = (e) => {
    const isDOMEvent = e && typeof e.target !== 'undefined';
    let p = null;
    if (isDOMEvent) {
      p = inputOnChange(e);
    } else {
      form.setValue(name, e);
    }

    if (onChange) {
      onChange(isDOMEvent ? form.getValues(name) : e, form);
    }

    return p || Promise.resolve(true);
  };

  if (typeof children === 'function') {
    return children({
      ...inputProps,
      label,
      errors: form.formState.errors[name] });

  }

  return children;
};